export function parseFloatNoNaN(value: string): number {
  const ret = parseFloat(value)
  return isNaN(ret) ? 0 : ret
}

export function parseIntNoNaN(value: string): number {
  const ret = parseInt(value, 10)
  return isNaN(ret) ? 0 : ret
}
